import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DIGITAL_TWIN_INLCM_4 = {
  title: `<span style="color: #BEE3FF;">Generate the proposed network plan</span>\n\nSummary view of the proposed planning \nbrief with download option.`,
  subtitle: "Digital Twin for Network Transformation",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_314"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_312"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_04_screen.png",
          imageStyle: { position: "absolute", bottom: "275px", right: "83px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_04_files.png",
          imageStyle: { position: "absolute", bottom: "0px", right: "625px" },
        },
      ]}
      pageNumber={"ENG_313"}
    />
  ),
};
